(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-blogs-display"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-blog-navigation li.parent-li a').forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.innerWidth < 768) {
          el.parentElement.classList.toggle('expanded')
          el.nextElementSibling.classList.toggle('expanded')
        }
      })
    })
    document.querySelector('.js-mobile-blog-nav').addEventListener('click', function () {
      document.querySelector('.js-blog-navigation').classList.toggle('active-mob-menu')
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var headings = document.querySelectorAll('.question-heading')

    function setOpen(heading, open) {
      var question = heading.closest('.question')
      var answer = document.getElementById(heading.getAttribute('aria-controls'))
      if (!question || !answer) return
      question.classList.toggle('expanded', open)
      heading.classList.toggle('expanded', open)
      answer.classList.toggle('expanded', open)
      heading.setAttribute('aria-expanded', open ? 'true' : 'false')
    }

    Array.prototype.forEach.call(headings, function (heading) {
      heading.addEventListener('click', function () {
        setOpen(heading, heading.getAttribute('aria-expanded') !== 'true')
      })
    })

    // Deep links: /pages/faq#melted opens that answer and scrolls to it.
    // Other pages (the contact form's deflection panel) rely on this, so it
    // has to work both on first load and when the hash changes on a page
    // that is already open.
    function openFromHash() {
      if (!window.location.hash) return
      var id
      try {
        id = decodeURIComponent(window.location.hash.slice(1))
      } catch (e) {
        return // malformed hash, nothing to open
      }
      // getElementById rather than querySelector: ids generated from block.id
      // are not always valid CSS selectors, and a throw here would take the
      // accordion's click handlers down with it.
      var target = document.getElementById(id)
      if (!target || !target.classList.contains('question')) return

      var heading = target.querySelector('.question-heading')
      if (!heading) return

      // Open rather than toggle — arriving at the same link twice should leave
      // the answer open, not close it.
      setOpen(heading, true)

      // block: 'center' keeps the answer clear of the sticky header without
      // this needing to know how tall the header is on any given breakpoint.
      requestAnimationFrame(function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'center' })
      })
    }

    openFromHash()
    window.addEventListener('hashchange', openFromHash)

    // Scroll spy for the pill rail. The blog's filters show which one is
    // selected; here the equivalent is which group you are currently reading,
    // which is the only thing that makes a sticky rail worth its space.
    //
    // Reads live geometry on scroll rather than positions captured in an
    // IntersectionObserver callback. The first attempt stored each heading's top
    // when the observer fired and compared those later, which is wrong: the
    // observer only fires on threshold crossings, so between them every stored
    // value is stale. It highlighted the wrong group five times out of six.
    var rail = document.querySelector('[data-faq-rail]')
    if (rail) {
      var pills = {}
      Array.prototype.forEach.call(rail.querySelectorAll('[data-faq-pill]'), function (pill) {
        pills[pill.getAttribute('data-faq-pill')] = pill
      })

      var headings = Array.prototype.filter.call(
        document.querySelectorAll('.faq-category[id^="faq-cat-"]'),
        function (h) { return pills[h.id.replace('faq-cat-', '')] }
      )

      if (headings.length > 1) {
        var current = null

        var list = rail.querySelector('.faq-rail__list')

        // Fade whichever edge has more track behind it, so an overflowing pill
        // reads as scrollable rather than sheared off. Per side, so the first pill
        // is never dimmed while the track sits at its start.
        function updateEdges() {
          if (!list) return
          var max = list.scrollWidth - list.clientWidth
          rail.classList.toggle('faq-rail--overflow-start', list.scrollLeft > 2)
          rail.classList.toggle('faq-rail--overflow-end', list.scrollLeft < max - 2)
        }

        // On a phone the active pill is often off-screen, which makes the rail
        // useless exactly when it should be orienting you. Nudge the track, not the
        // page — scrollIntoView here would drag the document with it.
        function revealPill(pill) {
          if (!list) return
          var l = list.getBoundingClientRect()
          var p = pill.getBoundingClientRect()
          var pad = 24
          if (p.left < l.left + pad) {
            list.scrollLeft -= l.left + pad - p.left
          } else if (p.right > l.right - pad) {
            list.scrollLeft += p.right - (l.right - pad)
          }
          updateEdges()
        }

        function setActive(slug) {
          if (slug === current) return
          current = slug
          Object.keys(pills).forEach(function (key) {
            var on = key === slug
            pills[key].classList.toggle('faq-pill--active', on)
            if (on) revealPill(pills[key])
          })
        }

        function update() {
          ticking = false
          // The reference line has to sit *below* where a clicked heading lands,
          // or the group you just jumped to reads as not-yet-reached and the
          // previous pill stays lit. scroll-margin-top parks a heading just under
          // the rail; this clears that by a comfortable margin rather than the 8px
          // it used to, which was close enough to be a coin flip.
          //
          // Clamped because the plain-header variant is not sticky: once it
          // scrolls away its bottom goes negative and every heading would count.
          var line = Math.max(rail.getBoundingClientRect().bottom + 28, 140)

          // At the foot of the document scrolling is clamped, so the last group or
          // two can never reach the line and the rail would stay stuck on an
          // earlier one while you read them. Whatever is on screen at the bottom
          // ends with the final group, so that is what to light.
          var atBottom =
            window.innerHeight + window.pageYOffset >=
            document.documentElement.scrollHeight - 4
          if (atBottom) {
            setActive(headings[headings.length - 1].id.replace('faq-cat-', ''))
            return
          }

          var found = headings[0]
          for (var i = 0; i < headings.length; i++) {
            if (headings[i].getBoundingClientRect().top <= line) found = headings[i]
            else break
          }
          if (found) setActive(found.id.replace('faq-cat-', ''))
        }

        var ticking = false
        // While a click-driven scroll is in flight the spy must not run, or the
        // groups it passes through light up on the way. A fixed timeout was the
        // first attempt and was wrong: smooth-scroll duration scales with
        // distance, so Products & ingredients to Autoship outran it. This waits
        // for the scroll to actually stop instead of guessing how long it takes.
        var locked = false

        function onScroll() {
          if (locked) return
          if (ticking) return
          ticking = true
          requestAnimationFrame(update)
        }

        function lockUntilSettled() {
          locked = true
          var last = window.pageYOffset
          var still = 0
          function watch() {
            if (!locked) return
            var now = window.pageYOffset
            // Two consecutive frames at the same offset means it has landed.
            still = now === last ? still + 1 : 0
            last = now
            if (still >= 2) { locked = false; return }
            requestAnimationFrame(watch)
          }
          requestAnimationFrame(watch)
        }

        // Hand control straight back if the reader takes over mid-flight.
        ['wheel', 'touchstart', 'keydown'].forEach(function (evt) {
          window.addEventListener(evt, function () {
            if (locked) { locked = false; onScroll() }
          }, { passive: true })
        })

        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll, { passive: true })
        if (list) {
          list.addEventListener('scroll', updateEdges, { passive: true })
          window.addEventListener('resize', updateEdges, { passive: true })
          updateEdges()
        }

        // Light the clicked pill straight away. Waiting for the scroll to settle
        // and the geometry to agree is what made this feel wrong even when the
        // maths was right — the feedback should be immediate, not derived.
        Object.keys(pills).forEach(function (slug) {
          pills[slug].addEventListener('click', function () {
            setActive(slug)
            lockUntilSettled()
          })
        })

        update()
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-kona-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const questions = document.querySelectorAll('.question-heading')
    questions.forEach(function (question) {
      question.addEventListener('click', function () {
        question.parentElement.classList.toggle('expanded')
        question.classList.toggle('expanded')
        var answer = question.nextElementSibling
        answer.classList.toggle('expanded')
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !Shopify.designMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
